import styled, { css } from 'styled-components';
import { ReactComponent as Whatsapp } from '../../assets/icons/talk-to-us.svg';
import { ReactComponent as Phone } from '../../assets/icons/phone-standart.svg';
import { ReactComponent as BarCode } from '../../assets/icons/bar-code.svg';

interface ImgProps {
  mobile?: boolean;
}
interface ContentProps {
  auth: boolean | null;
}

export const Wrap = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: border-box;
  background: ${(props) => props.theme.colors.primary};
`;
export const Title = styled.div<ContentProps>`
  display: flex;
  align-self: ${(props) => (props.auth ? 'flex-start' : 'center')};
  font-family: Arial, sans-serif;
  font-weight: bold;
  font-size: 1.5rem;
  @media screen and (min-width: 960px) {
    align-self: center;
  }

  ${(props) =>
    !props.auth &&
    css`
      @media screen and (max-width: 570px) {
        align-self: flex-start;
      }
    `}
`;

export const IconWhatsapp = styled(Whatsapp)`
  width: 75px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-right: ${(props) => ` 1px solid ${props.theme.colors.gray}`};
  fill: ${(props) => props.theme.colors.primaryDark1};

  margin-right: 15px;
  padding: 0 15px;
`;
export const IconBarCode = styled(BarCode)`
  width: 75px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-right: ${(props) => ` 1px solid ${props.theme.colors.gray}`};
  fill: ${(props) => props.theme.colors.primaryDark1};
  margin-right: 15px;
  padding: 0 15px;
`;
export const IconPhone = styled(Phone)`
  min-width: 75px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  fill: ${(props) => props.theme.colors.primaryDark1};
  padding: 0 15px;

  border-right: ${(props) => ` 1px solid ${props.theme.colors.gray}`};
  margin-right: 15px;
`;
export const Text = styled.div<ContentProps>`
  display: flex;
  align-self: ${(props) => (props.auth ? 'flex-start' : 'center')};
  font-family: Arial, sans-serif;
  font-size: 1.2rem;
  margin: 10px 0;
  color: ${(props) => props.theme.colors.gray};
  @media screen and (min-width: 960px) {
    align-self: center;
  }

  ${(props) =>
    !props.auth &&
    css`
      @media screen and (max-width: 570px) {
        align-self: flex-start;
      }
    `}
`;
export const IconNumberBarCode = styled.div`
  min-width: 75px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-right: ${(props) => ` 1px solid ${props.theme.colors.gray}`};
  margin-right: 15px;
  font-size: 0.7rem;
  color: ${(props) => props.theme.colors.primaryDark1};
  padding: 0 15px;

  font-style: bold;
`;

export const Content = styled.div<ContentProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  background: ${(props) => props.theme.colors.background.primary};
  border-radius: ${(props) =>
    Number(props.theme.borderRadius)
      ? `${props.theme.borderRadius}px`
      : '10px'};
  box-shadow: ${(props) => `  0px 5px 5px rgba(0, 0, 0, 0.5),
    inset 0px 10px 0px ${props.theme.colors.primaryDark2}`};

  ${(props) =>
    props.auth
      ? css`
          max-height: 65vh;
          padding: 40px;
        `
      : css`
          height: 65vh;
          justify-content: center;
          padding: 0px 40px;
        `}
`;

export const Button = styled.button`
  display: flex;
  align-items: center;
  color: ${(props) => props.theme.colors.primaryDark1};
  background: ${(props) => props.theme.colors.lightGray};
  border: ${(props) => ` 1px solid ${props.theme.colors.gray}`};
  box-shadow: ${(props) => ` 0px 0px 7px ${props.theme.colors.gray}`};
  border-radius: ${(props) =>
    Number(props.theme.borderRadius)
      ? `${props.theme.borderRadius}px`
      : '10px'};
  height: 75px;
  font-family: Arial, sans-serif;
  font-size: 1.5em;
  font-weight: bold;
  text-align: left;
  width: 100%;
  margin: 9px 0;
  padding: 5px 0;
  a {
    text-decoration: none;
    color: inherit;
    display: flex;
    align-items: center;
  }
  @media screen and (min-width: 960px) {
    width: 50%;
  }
`;

export const Img = styled.img<ImgProps>`
  max-width: 100%;
  max-height: 100%;
`;

export const BottonLogo = styled.div`
  max-height: 10vh;

  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 0;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`;
export const Address = styled.div`
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  color: ${(props) => props.theme.colors.white};
  padding: 15px 35px;
  background: ${(props) => props.theme.colors.primaryDark2};
`;
